import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ImportJobSampleCsvRowsQueryVariables = Types.Exact<{
  input: Types.GetImportJobSampleCsvRowsInput;
}>;


export type ImportJobSampleCsvRowsQuery = { importJobSampleCsvRows: { rows: Array<{ values: Array<string> }> } };


export const ImportJobSampleCsvRowsDocument = /*#__PURE__*/ gql`
    query importJobSampleCsvRows($input: GetImportJobSampleCsvRowsInput!) {
  importJobSampleCsvRows(data: $input) {
    rows {
      values
    }
  }
}
    `;

export function useImportJobSampleCsvRowsQuery(options: Omit<Urql.UseQueryArgs<ImportJobSampleCsvRowsQueryVariables>, 'query'>) {
  return Urql.useQuery<ImportJobSampleCsvRowsQuery, ImportJobSampleCsvRowsQueryVariables>({ query: ImportJobSampleCsvRowsDocument, ...options });
};